import { useState } from "react";
import { toast } from "sonner";
import { Copy, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { api } from "../lib/api";

export const DemoCloneButton = () => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (!window.confirm("تحديث نسخة الديمو من بيانات شركتك؟ ستُستبدل بيانات الديمو الحالية بنسخة مُخفاة الهوية (أسماء وأرقام وهمية، بدون وثائق).")) return;
    setBusy(true);
    try {
      await api.demoClone();
      for (let i = 0; i < 120; i += 1) {
        await new Promise((r) => setTimeout(r, 2500));
        const s = await api.demoCloneStatus();
        if (s.status === "done") { toast.success(`تم تحديث نسخة الديمو (${s.docs} سجل) ✅`); return; }
        if (s.status === "error") { toast.error(`فشل النسخ: ${s.error}`); return; }
      }
      toast.info("النسخ ما زال جارياً، تحقق لاحقاً");
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر بدء النسخ"); }
    finally { setBusy(false); }
  };
  return (
    <Button variant="outline" size="sm" data-testid="demo-clone-button" disabled={busy} onClick={run}
      className="gap-1.5 border-indigo-200 text-indigo-700 hover:bg-indigo-50">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Copy className="h-4 w-4" />} <span className="hidden sm:inline">تحديث نسخة الديمو</span>
    </Button>
  );
};
